module.exports = __webpack_public_path__ + "static/img/voc-popup-img.846ff6c.png";